export function share() {
    return {
        copied: false,

        shareOn(platform) {
            const url = encodeURIComponent(this.$root.dataset.url);
            const title = encodeURIComponent(this.$root.dataset.title);
            const urls = {
                linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`,
                facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
                twitter: `https://twitter.com/intent/tweet?text=${title}&url=${url}`,
            };
            if (urls[platform]) {
                window.open(urls[platform], `${platform}-share-dialog`, 'width=800,height=600');
            }
        },

        copyLink() {
            const url = this.$root.dataset.url;
            const done = () => {
                this.copied = true;
                setTimeout(() => { this.copied = false; }, 2000);
            };

            // navigator.clipboard vereist een secure context (HTTPS/localhost).
            // Op onveilige origins (bv. lokale http) valt hij terug op execCommand.
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(url).then(done).catch(() => this.fallbackCopy(url, done));
            } else {
                this.fallbackCopy(url, done);
            }
        },

        fallbackCopy(text, done) {
            const ta = document.createElement('textarea');
            ta.value = text;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.top = '-9999px';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.focus();
            ta.select();
            try { document.execCommand('copy'); } catch (e) { /* stil */ }
            document.body.removeChild(ta);
            done();
        },
    };
}

export function menu() {
    return {
        open: window.innerWidth >= 1280,
        openFilters: window.innerWidth >= 1280,

        init() {
            this.open = window.innerWidth >= 1280;
            this.openFilters = window.innerWidth >= 1280;

            window.addEventListener('resize', () => {
                this.open = window.innerWidth >= 1280;
                this.openFilters = window.innerWidth >= 1280;
            });
        }
    };
}